import {
  isNonEmpty,
  isValidEmail,
  isValidUKPostcode,
  isValidDateDDMMYYYY,
} from "../validators/validators";

export const initialEnhancedState = {
  personal: { firstName: "", lastName: "", dob: "", email: "", phone: "" },
  idDoc: { type: "id_card" },
  address: {
    buildingNumber: "",
    buildingName: "",
    street: "",
    county: "",
    town: "",
    postcode: "",
  },
};

/* ------------------ Enhanced Check validate ---------------- */
export const validateEnhanced = (formData) => {
  const next = { personal: {}, address: {}, idDoc: {} };

  if (!isNonEmpty(formData.personal.firstName))
    next.personal.firstName = "Required";
  if (!isNonEmpty(formData.personal.lastName))
    next.personal.lastName = "Required";

  const dob = formData.personal.dob;
 if (!isNonEmpty(dob)) {
   next.personal.dob = "Required";
 } else if (!isValidDateDDMMYYYY(dob)) {
   next.personal.dob = "Invalid date format";
 } else {
   // Parse DD/MM/YYYY safely
   const [day, month, year] = dob.split("/").map(Number);
   const birthDate = new Date(year, month - 1, day);
   const today = new Date();

   let age = today.getFullYear() - birthDate.getFullYear();
   const hasHadBirthdayThisYear =
     today.getMonth() > birthDate.getMonth() ||
     (today.getMonth() === birthDate.getMonth() &&
       today.getDate() >= birthDate.getDate());

   if (!hasHadBirthdayThisYear) {
     age--;
   }

  //  if (age < 18) {
  //    next.personal.dob = "Client must be at least 18 years old";
  //  }
 }

  if (!isNonEmpty(formData.personal.email)) next.personal.email = "Required";
  else if (!isValidEmail(formData.personal.email))
    next.personal.email = "Invalid email address";

  // if (!isNonEmpty(formData.personal.phone)) {
  //   next.personal.phone = "Required";
  // } else {
  //   const digitsOnly = String(formData.personal.phone || "").replace(/\D/g, "");
  //   if (digitsOnly.length !== 12) {
  //     next.personal.phone = "Required"; // or "Invalid phone number"
  //   }
  // }

  //  Require at least ONE: building number OR building name
  const bn = formData.address.buildingNumber;
  const bname = formData.address.buildingName;
  if (!isNonEmpty(bn) && !isNonEmpty(bname)) {
    const msg = "Enter building number or building name";
    next.address.buildingNumber = msg;
    next.address.buildingName = msg;
  }

  if (!isNonEmpty(formData.address.street)) next.address.street = "Required";
  if (!isNonEmpty(formData.address.county)) next.address.county = "Required";
  if (!isNonEmpty(formData.address.town)) next.address.town = "Required";

  if (!isNonEmpty(formData.address.postcode)) {
    next.address.postcode = "Required";
  } else if (!isValidUKPostcode(formData.address.postcode)) {
    next.address.postcode = "Invalid UK postcode";
  }

  if (!isNonEmpty(formData.idDoc.type)) next.idDoc.type = "Required";

  if (!Object.values(next.personal).some(Boolean)) delete next.personal;
  if (!Object.values(next.address).some(Boolean)) delete next.address;
  if (!Object.values(next.idDoc).some(Boolean)) delete next.idDoc;

  return next; // empty object => valid
};
